<template>
  <v-app>
  <!-- <div id="app"> -->

    <fs-topbar @monitorarSwitch="monitorarSwitch" :menuStatic='fixarMenu'/>

    <div class="content" v-bind:class="{ 'content_left': fixarMenu }">
      <router-view/>
    </div>

    <fs-footer :isActive='fixarMenu'/>

      <!-- <div class="container is-fluid">
        <router-view/>
      </div> -->
  <!-- </div> -->
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: ['isActive'],
  data: () => ({
    fixarMenu: true
  }),
  methods: {
    ...mapActions('login', [
      'check',
      'login',
      'logout',
      'recuperaLogin'
    ]),
    monitorarSwitch (val) {
      this.fixarMenu = val
    }
  },
  computed: {
    ...mapState('login', [
      'logged',
      'usuario'
    ])
  },
  mounted: function () {
    // Verifica se existe o Token e no caso de F5 recupera o login da aplicação pelo refresh_Token
    if (localStorage.getItem('api_refreshToken') !== null) {
      this.recuperaLogin()
    }
  }
}

</script>

<style lang="scss">
.content {
    width:100%;
    background: #F0F0F0;
    border: 1px solid #CCC;
    height: 100%;
    margin: 25px auto;
    //padding-left: 280px; // Para fixar o menu a esquerda
}

.content_left {
  padding-left: 280px;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
